__turbopack_context__.v({
  "className": "poiret_one_10064b60-module__UzLlmq__className",
});
